import { SESSION_FORCED_M2E_CAMPAIGNS } from '../constants';

type SelectedM2ECampaigns = { [groupId: string]: number };

export const forceM2ECampaign = (groupId: number, testId: number) => {
  if (isNaN(groupId) || isNaN(testId)) return;

  const selectedM2eCampaigns: SelectedM2ECampaigns = JSON.parse(
    window.sessionStorage.getItem(SESSION_FORCED_M2E_CAMPAIGNS) || '{}'
  );
  selectedM2eCampaigns[groupId] = testId;
  window.sessionStorage.setItem(SESSION_FORCED_M2E_CAMPAIGNS, JSON.stringify(selectedM2eCampaigns));
  window.location.reload();
};

export const getForcedM2ECampaigns = () => {
  return JSON.parse(window.sessionStorage.getItem(SESSION_FORCED_M2E_CAMPAIGNS) || '{}');
};
